// extracted by mini-css-extract-plugin
export default {"content":"Upside_content__g5mSY","exit":"Upside_exit__bjCTz"};